import Switch from "@mui/material/Switch";
import Typography from "@mui/material/Typography";
import { Box, Tooltip } from "@mui/material";
import { Info } from "@mui/icons-material";
import useQueryState from "../../hooks/useQueryState";

const ToggleBox = ({
  title,
  toggleKey,
  disabled,
  isChecked,
  openDialog,
}: any) => {
  const { queryState, setQueryState } = useQueryState();

  const handleToggleChange = () => {
    switch (toggleKey) {
      case "droughtEvents":
        setQueryState({
          droughtEvents: !queryState.droughtEvents,
        });
        break;
      case "ipcScore":
        setQueryState({
          ipcScore: !queryState.ipcScore,
        });
        break;
      default:
        break;
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Box display="flex" gap="5px" alignItems="center">
        <Typography variant="subtitle1">{title}</Typography>
        <Tooltip
          title={
            toggleKey === "droughtEvents"
              ? "This dataset corresponds to drought statistics from the International Disasters Database available at the level the Admin 2 level."
              : "Drought statistics from the Integrated Food Security Phase Classification (IPC) scale for Acute Food Insecurity. IPC scores are generated at the level of FEWS NET livelihood zones (higher resolution than Admin 2), but for each area, we use the maximum, annual IPC value for the chosen Admin level.​"
          }
        >
          <Info sx={{ color: "#6C6C89" }} fontSize="small" />
        </Tooltip>
      </Box>
      <Switch
        onChange={handleToggleChange}
        checked={isChecked}
        disabled={disabled}
        size="small"
      />
    </Box>
  );
};

export default ToggleBox;
